import { localStorage } from 'dibs-browser-storage';

const PROMO_CODE_STORAGE_KEY = 'promoCodeNotificationShown';

export const discount = 15;
export const code = 'SAVE15';

export const setPromoCodeNotificationShown = () => {
    localStorage.setItem(PROMO_CODE_STORAGE_KEY, true);
};

export const wasPromoCodeNotificationShown = () => !!localStorage.getItem(PROMO_CODE_STORAGE_KEY);



// WEBPACK FOOTER //
// ./src/utils/promoCode.es.js